import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useCloseOnEscape } from '../reactHooks.js';
import './dialog.scss';

function Dialog(props) {
  var {
    children,
    className,
    close = () => {},
    darkMode = false,
    header,
    height = 500,
    onMouseDown = null,
    style = {},
    width = 400,
    tabs = [],
    currentTab = ''
  } = props;
  var dialogRef = useRef(null);
  var [dialogOpen, setDialogOpen] = useState(false);
  var [dialogStyle, onMouseDownDrag] = useDragDialog(dialogRef);
  useCloseOnEscape(close);
  useEffect(() => {
    setTimeout(() => setDialogOpen(true), 10);
  }, []);

  var handleTabClick = tab => {
    var {
      onTabChange
    } = props;

    if (typeof onTabChange === 'function') {
      onTabChange(tab);
    }
  };

  if (typeof onMouseDown !== 'function') {
    onMouseDown = () => {};
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classNames('dialog', {
      dialogOpen,
      darkMode
    }, className),
    onMouseDown: onMouseDown,
    ref: dialogRef,
    style: {
      height,
      width,
      ...dialogStyle,
      ...style
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("span", null, header), !!tabs.length && /*#__PURE__*/React.createElement("div", {
    className: "tabsContainer"
  }, tabs.map(tab => /*#__PURE__*/React.createElement("div", {
    className: classNames('tab', {
      selected: currentTab === tab
    }),
    key: tab,
    onClick: () => handleTabClick(tab)
  }, tab)))), /*#__PURE__*/React.createElement("div", {
    className: "dragHandle",
    onMouseDown: onMouseDownDrag
  }), /*#__PURE__*/React.createElement("div", {
    className: "closeX",
    onClick: close
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "dialogContentContainer"
  }, children));
}

function useDragDialog(dialogRef) {
  var [dialogStyle, setDialogStyle] = useState({});
  var moveData = {};

  var onMouseDown = event => {
    if (event.button !== 0) {
      return;
    }

    var obj = dialogRef.current;
    var box = obj.getBoundingClientRect();
    var offsetX = event.clientX - box.x;
    var offsetY = event.clientY - box.y;
    moveData.offsetX = offsetX;
    moveData.halfWidth = box.width / 2;
    moveData.offsetY = offsetY;
    moveData.halfHeight = box.height / 2;
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
    document.body.classList.add('noSelect');
  };

  var onMouseMove = event => {
    var newX = event.clientX - moveData.offsetX;
    newX += moveData.halfWidth;
    newX = Math.max(newX, moveData.halfWidth);
    newX = Math.min(newX, window.innerWidth - moveData.halfWidth);
    var newY = event.clientY - moveData.offsetY;
    newY += moveData.halfHeight;
    newY = Math.max(newY, moveData.halfHeight);
    newY = Math.min(newY, window.innerHeight - moveData.halfHeight);
    setDialogStyle({
      left: newX,
      top: newY
    });
  };

  var onMouseUp = event => {
    moveData = {};
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);
    document.body.classList.remove('noSelect');
  };

  return [dialogStyle, onMouseDown];
}

export default Dialog;